// H-77 — selector de año de "Mi perfil" (`.rp2-year`). Antes permitía retroceder sin tope; se
// acota a 2 años atrás + el actual (3 valores navegables en total): no hay reconocimientos más
// viejos que valga la pena mostrar, y sin tope el botón "<" quedaba habilitado para siempre.

/** Cuántos años hacia atrás del actual se pueden navegar. 2 = actual + 2 atrás. */
export const RP2_YEARS_BACK = 2;

/** Año más antiguo navegable del selector, dado el año actual (inyectable en tests). */
export function rp2MinSelectableYear(currentYear: number): number {
  return currentYear - RP2_YEARS_BACK;
}
